import { motion } from "framer-motion";
import { CONTACT } from "../../lib/landingData";
import { useLang } from "../../i18n/LanguageContext";

const WhatsAppIcon = ({ className }) => (
  <svg viewBox="0 0 32 32" className={className} fill="currentColor" aria-hidden="true">
    <path d="M16.001 3.2C9.055 3.2 3.4 8.854 3.4 15.8c0 2.22.58 4.386 1.683 6.293L3.2 28.8l6.86-1.797a12.56 12.56 0 0 0 5.94 1.513h.005c6.945 0 12.6-5.654 12.6-12.6 0-3.366-1.31-6.53-3.69-8.91A12.52 12.52 0 0 0 16.001 3.2Zm0 22.99h-.004a10.45 10.45 0 0 1-5.322-1.457l-.382-.227-3.97 1.04 1.06-3.87-.249-.397a10.42 10.42 0 0 1-1.597-5.582c0-5.773 4.7-10.472 10.468-10.472 2.797 0 5.425 1.09 7.402 3.07a10.4 10.4 0 0 1 3.064 7.407c0 5.773-4.7 10.472-10.47 10.472Zm5.74-7.842c-.315-.158-1.862-.919-2.15-1.024-.288-.105-.498-.158-.708.158-.21.315-.813 1.024-.997 1.234-.184.21-.367.236-.682.079-.315-.158-1.33-.49-2.532-1.562-.936-.835-1.568-1.866-1.752-2.181-.184-.315-.02-.485.138-.642.142-.141.315-.367.472-.55.158-.184.21-.315.315-.525.105-.21.053-.394-.026-.552-.079-.158-.708-1.707-.97-2.337-.256-.613-.516-.53-.708-.54l-.603-.01c-.21 0-.552.079-.84.394-.288.315-1.102 1.077-1.102 2.626 0 1.55 1.128 3.046 1.286 3.256.158.21 2.22 3.39 5.377 4.753.751.324 1.337.518 1.794.663.753.24 1.439.206 1.981.125.604-.09 1.862-.761 2.124-1.496.263-.735.263-1.365.184-1.496-.079-.131-.288-.21-.603-.367Z"/>
  </svg>
);

export const FloatingWhatsApp = () => {
  const { t } = useLang();
  const href = CONTACT.whatsappChat;

  return (
    <motion.a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float"
      aria-label={t.footer.whatsapp}
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1.2, type: "spring", stiffness: 260, damping: 18 }}
      whileHover={{ scale: 1.06 }}
      whileTap={{ scale: 0.94 }}
      className="group fixed bottom-5 right-5 sm:bottom-7 sm:right-7 z-[60] flex items-center gap-3"
    >
      <span className="pointer-events-none absolute right-full mr-3 whitespace-nowrap rounded-full bg-green px-4 py-2
                       text-sm font-medium text-cream opacity-0 translate-x-2 shadow-lg transition-all duration-300
                       group-hover:opacity-100 group-hover:translate-x-0 hidden sm:block">
        {t.footer.whatsapp}
      </span>
      <span className="relative flex h-14 w-14 items-center justify-center rounded-full bg-[var(--ink)] text-[var(--page)] shadow-xl shadow-black/20 ring-1 ring-[var(--hairline)]">
        <span className="absolute inset-0 rounded-full bg-[var(--ink)] animate-ping opacity-20" />
        <WhatsAppIcon className="relative h-7 w-7" />
      </span>
    </motion.a>
  );
};
